import { Avatar, Box, Chip, Icon, IconButton, Typography } from '@shared/ui';
import type React from 'react';
import { Link } from 'react-router-dom';

interface GoogleDriveRowProps {
  connected: boolean;
  migrationRequired?: boolean;
  iconSrc?: string;
  email?: string;
  to?: string;
  onOpenSettings: () => void;
  onOpenMenu: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const GoogleDriveRow: React.FC<GoogleDriveRowProps> = ({
  connected,
  migrationRequired = false,
  iconSrc,
  email,
  to,
  onOpenSettings,
  onOpenMenu,
}) => {
  const statusLabel = migrationRequired ? 'Reconnect' : connected ? 'Connected' : 'Not connected';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', p: 1.25 }}>
      <Box
        component={to ? Link : 'div'}
        to={to as any}
        onClick={!to ? onOpenSettings : undefined}
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          cursor: 'pointer',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <Avatar
          variant="rounded"
          sx={{ width: 28, height: 28, mr: 1, borderRadius: 6, bgcolor: 'transparent' }}
          src={iconSrc}
          imgProps={{ referrerPolicy: 'no-referrer' }}
        >
          <Icon sx={{ fontSize: 18 }}>drive_folder_upload</Icon>
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2">Google Drive</Typography>
          <Typography variant="caption" color="text.secondary">
            {email || 'Not connected'}
          </Typography>
        </Box>
      </Box>
      <Chip
        label={statusLabel}
        size="small"
        sx={(theme) => ({
          bgcolor: migrationRequired
            ? theme.extendedColors.sunny[100]
            : connected
              ? theme.extendedColors.sage[100]
              : theme.extendedColors.cement[100],
          color: migrationRequired
            ? theme.extendedColors.sunny[700]
            : connected
              ? theme.extendedColors.sage[600]
              : theme.extendedColors.cement[500],
          mr: 1,
        })}
      />
      <IconButton size="small" onClick={onOpenMenu}>
        <Icon>more_horiz</Icon>
      </IconButton>
    </Box>
  );
};

export default GoogleDriveRow;
